import React from "react";
import http from '../../../services/http.module';
import CircularLoading from '@material-ui/core/CircularProgress';
import { Typography , Button } from "@material-ui/core";

class Payment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      message: {},
      isLoading: false,
      price: 0
    };
  }

  componentDidMount() {
    this.props.ActivateNext(false);
    this.setState({
      isLoading: true
    }, this.onSubmitionStart);
  }

  onSubmitionStart = () => {
    const UserInfo = this.props.GetStepData('3');
    const turnID = this.props.GetStepData('2');
    const modePrice = this.props.GetStepData('1').price;
    
    if(!!UserInfo.WorkshopType) {
      this.setState({
        price: UserInfo.WorkshopType * modePrice
      })
    } else {
      this.setState({
        price: modePrice
      })
    }
    
    http.SubmitReservation(turnID.reservedDateId, UserInfo)
      .then(this.onSubmitionSuccess)
      .catch(this.onSubmitionFailed)
      .finally(this.onSubmitionEnd);
  }
  onSubmitionSuccess = (result) => {
    this.setState({ 
      message: {
        state: true,
        title: 'رفتن به درگاه پرداخت',
        jsx: <>
        <div className='row p-3'>
          <div className='col-12 text-center'>
            <Typography variant='h6' className='font-weight-bold' align='center'>
              مبلغ قابل پرداخت : <span className='text-success'>
                  {result.payment.amount} تومان
                </span>
            </Typography>
          </div>
        </div>
        <div className='row'>
          <div className='col-12 text-center'>
          <Button variant='contained' color='secondary'>
            <a href={result.payment.url} target='_blank' className='text-white' rel='noreferrer'>
              انتقال به درگاه بانک
            </a>
          </Button>
          </div>
        </div>
        </>
      }
    })
  }
  onSubmitionFailed = (error) => {
    this.setState({
      message: {
        state: false,
        title: 'خطا',
        jsx: <> 
          <Typography variant='h6' align='center' className='p-2'>
            خطا در انجام عملیات
          </Typography>
          <div className='row'>
            <div className='col-12 text-center'>
              <Button onClick={this.props.GoBack} variant='contained' color='secondary' >
                بازگشت و تلاش مجدد
              </Button>
            </div>
          </div>
        </>
      }
    })
  }
  onSubmitionEnd = () => {
    this.setState({
      isLoading: false
    })
  }

  render() {
    return (
      <div>
        {this.state.isLoading ? 
          <CircularLoading />
        : <> 
          {!!this.state.message ? <div className='row'>
            <div className='col-12 text-center'> 
            <Typography variant='h5' align='center' className={`${this.state.message.status ? 'text-success' : 'text-error'}`}>
              {this.state.message.title}
            </Typography>
            </div>
            <div className='col-12'>
              {this.state.message.jsx}
            </div>
          </div> : <> درحال بارگذاری </>}
        </>}
      </div>
    )
  }
}

export default Payment;